<app-terms-of-service-content
  [pageData]="pageData"
></app-terms-of-service-content>
<app-terms-of-service-support
  [pageData]="pageData"
></app-terms-of-service-support>
